import React from "react";

export const PayModalVeil = ({showModal, actions}) => (
    <div
        className="PayModal-veil"

        onClick={() => {
            if (showModal) {
                actions.hidePayModal()
            }
        }}

    />
);



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/PayModalVeil/PayModalVeil.js